import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { VerifyEmailComponent } from './containers/verify-email/verify-email.component';

const routes: Routes = [
  {
    path: 'verify-email',
    component: VerifyEmailComponent,
    loadChildren: () =>
      import(`./containers/verify-email/verify-email.module`).then(
        m => m.VerifyEmailModule
      ),
  },
  {
    path: 'register',
    loadChildren: () =>
      import(`./containers/register/register.module`).then(
        m => m.RegisterModule
      ),
  },
  {
    path: 'login',
    loadChildren: () =>
      import(`./containers/login/login.module`).then(m => m.LoginModule),
  },
  {
    path: 'reset-password',
    loadChildren: () =>
      import(`./containers/reset-password/reset-password.module`).then(
        m => m.ResetPasswordModule
      ),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import(`./profile/profile.module`).then(m => m.ProfileModule),
  },
  {
    path: 'courses-and-groups',
    loadChildren: () =>
      import(`./courses-and-groups/courses-and-groups.module`).then(
        m => m.CoursesAndGroupsModule
      ),
  },
  {
    path: 'materials',
    loadChildren: () =>
      import(`./materials/materials.module`).then(m => m.MaterialsModule),
  },
  {
    path: 'events',
    loadChildren: () =>
      import(`./events/events.module`).then(m => m.EventsModule),
  },
  {
    path: 'users',
    loadChildren: () => import(`./users/users.module`).then(m => m.UsersModule),
  },
  {
    path: 'сompanies',
    loadChildren: () =>
      import(`./companies/companies.module`).then(m => m.CompaniesModule),
  },
  {
    path: 'vacancies',
    loadChildren: () =>
      import(`./vacancies/vacancies.module`).then(m => m.VacanciesModule),
  },
  {
    path: 'student-works',
    loadChildren: () =>
      import(`./student-works/student-works.module`).then(
        m => m.StudentWorksModule
      ),
  },
  {
    path: 'student-results',
    loadChildren: () =>
      import('./student-results/student-results.module').then(
        m => m.StudentResultsModule
      ),
  },
  {
    path: 'courses/:coursesId/groups/:groupsId/work-debtors',
    loadChildren: () =>
      import('./work-debtors/work-debtors.module').then(
        m => m.WorkDebtorsModule
      ),
  },
  {
    path: 'esdp',
    loadChildren: () => import('./esdp/esdp.module').then(m => m.EsdpModule),
  },
  {
    path: 'archive',
    loadChildren: () =>
      import('./archive/archive.module').then(m => m.ArchiveModule),
  },
  {
    path: 'sales',
    loadChildren: () => import('./sales/sales.module').then(m => m.SalesModule),
  },
  {
    path: 'accountant',
    loadChildren: () =>
      import('./accountant/accountant.module').then(m => m.AccountantModule),
  },
  {
    path: 'lead-register-form',
    loadChildren: () =>
      import('./containers/lead-register-form/lead-register-form.module').then(
        m => m.LeadRegisterFormModule
      ),
  },
  {
    path: 'enrollees',
    loadChildren: () =>
      import(
        './containers/register-for-presentation/register-for-presentation.module'
      ).then(m => m.RegisterForPresentationModule),
  },
  { path: '', redirectTo: '/profile', pathMatch: 'full' },
  { path: '**', redirectTo: '/profile' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
